(() => {
  const navigation = document.querySelector('[data-yb-mobile-nav]');
  if (!navigation || navigation.dataset.ready) return;
  navigation.dataset.ready = 'true';
  const menu = document.querySelector('.yb-department-menu');
  const departmentButton = navigation.querySelector('[data-yb-mobile-departments]');
  if (menu && departmentButton) {
    if (!menu.id) menu.id = 'YubzDepartmentMenu';
    departmentButton.setAttribute('aria-controls', menu.id);
    const reflectOpen = () => departmentButton.setAttribute('aria-expanded', String(menu.open));
    menu.addEventListener('toggle', reflectOpen);
    reflectOpen();
  }
  navigation.addEventListener('click', event => {
    const button = event.target.closest('button');
    if (!button || !navigation.contains(button)) return;
    event.stopPropagation();
    if (button.hasAttribute('data-yb-mobile-departments')) {
      if (!menu) { location.assign(button.dataset.fallback); return; }
      menu.open = true;
      departmentButton.setAttribute('aria-expanded', 'true');
      menu.scrollIntoView({ behavior: 'instant', block: 'start' });
      menu.querySelector('summary')?.focus({ preventScroll: true });
    }
    if (button.hasAttribute('data-yb-mobile-search')) {
      const input = document.getElementById('YubzSearch');
      if (!input) { location.assign(button.dataset.fallback); return; }
      if (menu) menu.open = false;
      input.scrollIntoView({ behavior: 'instant', block: 'center' });
      input.focus({ preventScroll: true });
    }
  });
})();
